import { html } from "lit";
import { when } from "lit/directives/when.js";
import { tokenMap } from "../../../../common/utils";
export const defaultSourceRender = (source) => html `<li class="contents">
    <a
      aria-label=${source.accessibleName}
      part=${tokenMap({
    source: true,
    [source.parts]: !!source.parts
})}
      href=${source.url}
      target="_blank"
    >
      ${when(source.caption, () => html `<span
          part=${tokenMap({
    "source-caption": true,
    [source.parts]: !!source.parts
})}
        >
          ${source.caption}
        </span>`)}
    </a>
  </li>`;
